import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=be6b5de0&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderSummary.vue?vue&type=style&index=0&id=be6b5de0&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./OrderSummary.vue?vue&type=style&index=1&id=be6b5de0&prod&lang=scss&scoped=true")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "be6b5de0",
  "d373b740"
  
)

export default component.exports